import { useState } from 'react';
import { motion } from 'framer-motion';
import loja1 from '../../assets/imagens/loja1.jpeg';
import loja2 from '../../assets/imagens/loja2.jpeg';
import loja3 from '../../assets/imagens/loja3.jpeg';
import loja4 from '../../assets/imagens/loja4.jpeg';
import './Space.scss';

const spaceImages = [
  {
    url: loja1,
    title: 'Nossa Lavanderia'
  },
  {
    url: loja2,
    title: 'Espaço Moderno'
  },
  {
    url: loja3,
    title: 'Ambiente Limpo'
  },
  {
    url: loja4,
    title: 'Equipamentos Modernos'
  }
];

const amenities = [
  { icon: 'ri-wifi-line', title: 'Wi-Fi Grátis' },
  { icon: 'ri-temp-cold-line', title: 'Ar-Condicionado' },
  { icon: 'ri-truck-line', title: 'Delivery na Região' },
  { icon: 'ri-camera-line', title: 'Câmeras de Segurança' },
  { icon: 'ri-leaf-line', title: 'Produtos Ecológicos' },
  { icon: 'ri-wheelchair-line', title: 'Acessibilidade' },
  { icon: 'ri-lightbulb-line', title: 'Iluminação LED' },
  { icon: 'ri-shield-check-line', title: 'Ambiente Seguro' }
];

export default function Space() {
  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % spaceImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + spaceImages.length) % spaceImages.length);
  };

  return (
    <section className="space" id="sobre">
      <div className="container">
        <motion.div 
          className="space-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Nosso Espaço</h2>
          <p className="section-subtitle">Ambiente moderno, limpo e confortável para você</p>
        </motion.div>

        <div className="space-content">
          <motion.div 
            className="space-carousel"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="carousel-container">
              <img 
                src={spaceImages[currentImage].url} 
                alt={spaceImages[currentImage].title}
                className="carousel-image"
              />
              <div className="carousel-caption">
                <h4>{spaceImages[currentImage].title}</h4>
              </div>
            </div>
            
            <button onClick={prevImage} className="carousel-btn prev" aria-label="Anterior">
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button onClick={nextImage} className="carousel-btn next" aria-label="Próximo">
              <i className="ri-arrow-right-s-line"></i>
            </button>

            <div className="carousel-dots">
              {spaceImages.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentImage ? 'active' : ''}`}
                  onClick={() => setCurrentImage(index)}
                  aria-label={`Ir para imagem ${index + 1}`}
                />
              ))}
            </div>
          </motion.div>

          <motion.div 
            className="space-amenities"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3>Comodidades</h3>
            <div className="amenities-grid">
              {amenities.map((amenity, index) => (
                <motion.div
                  key={index}
                  className="amenity-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  <div className="amenity-icon">
                    <i className={amenity.icon}></i>
                  </div>
                  <span>{amenity.title}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}